import {spawnSync} from 'child_process';

import {parseVersion} from './util.js';

/**
 * @return {Array}
 */
export function version() {
	const proc = spawnSync('npm', ['-v']);

	const out = proc.output.toString();

	if (!out) {
		return out;
	}

	const version = out.replace(/[^0-9\\.]/g, '');

	return parseVersion(version);
}
